// extracted by mini-css-extract-plugin
export default {"root":"Button-root_root__1sB-5","noPadding":"Button-root_noPadding__9MKlZ","before":"Button-root_before__FA2Dr","after":"Button-root_after__1QVFe"};